const i = [
  { title: "PS Light", icon: "sun", value: "ps-light" },
  { title: "PS Dark", icon: "moon", value: "ps-dark" },
  { title: "Sisal Light", icon: "sun", value: "sisal-light" },
  { title: "Sisal Dark", icon: "moon", value: "sisal-dark" }
], t = [
  "ps-light",
  "ps-dark",
  "sisal-light",
  "sisal-dark"
];
export {
  t as FUSION_THEMES,
  i as themesMetadata
};
//# sourceMappingURL=themes.mjs.map
